<template>
    <div ref="dropdownParent" @click="showDropdownItems" class="jbs-dropdown">
        <div  class="jbs-dropdown-activator" >
        <slot></slot>
        </div>
        <slot name="dropdown"></slot>
    </div>
</template>

<script>
export default {

data(){
    return {
      showDropdown: false
    }
},

methods:{
    showDropdownItems(){
        this.showDropdown = !this.showDropdown;
    }
}

}
</script>

<style scoped>

.jbs-dropdown{
    display: inline-block;
    cursor: pointer;
}

.jbs-dropdown-activator{
    margin: 3px;
}

</style>